// Library Imports
import React, { FC } from 'react';

type TableBodyProps = {
  rows: any[];
  columns: any[];
  selectedIds: Number[];
  setSelectedIds: Function;
  tableColumnExtensions: any;
  dataProviders?: any;
  onRowClick?: Function;
};

const TableMainBody: FC<TableBodyProps> = ({
  rows,
  columns,
  selectedIds,
  setSelectedIds,
  tableColumnExtensions,
  dataProviders,
  onRowClick,
}) => {
  return (
    <React.Fragment>
      {rows?.length > 0 && <tbody>
        {(
          rows?.map((row, rowIndex) => {
            const id = row?.id;
            const odd = rowIndex % 2 === 1;
            // IS SELECTED ID
            const isRowSelected = selectedIds?.includes(id);
            // ONCHANGE OF SELECTIONS CHECKBOX
            const onChange = () => {
              const ids = isRowSelected
                ? selectedIds?.filter((ele) => ele !== id)
                : [...selectedIds, id];
              setSelectedIds(ids);
            };
            return (
              <tr
                key={rowIndex}
                style={{
                  backgroundColor: odd ? '#f1f1f1' : 'unset',
                  //   backgroundColor: 'transparent'
                }}
              >
                <td
                  style={{
                    backgroundColor: 'transparent',
                    fontFamily: 'inherit',
                    fontSize: '12px',
                    padding: '20px 10px',
                    blockSize: 20,
                    insetBlockEnd: 'none',
                  }}
                >
                  <input
                    type='checkbox'
                    className='cursor-pointer'
                    checked={Boolean(isRowSelected)}
                    onChange={onChange}
                  />
                </td>
                {columns?.map((col, colIndex) => {
                  // GET COLUMN EXTENSION
                  const columnExtension = tableColumnExtensions?.find(
                    (item: { columnName: any }) =>
                      item?.columnName === col?.name
                  );
                  // GET EXTENSION WITH
                  const width = columnExtension?.width || 100;
                  const dataProvider = dataProviders?.find(
                    (provider: { columnName: any[] }) =>
                      provider?.columnName[0] === col?.name
                  );

                  return (
                    <td
                      key={colIndex}
                      color={'primary'}
                      width={columnExtension?.width || 100}
                      style={{
                        minInlineSize: width,
                        backgroundColor: 'transparent',
                        fontFamily: 'inherit',
                        fontSize: '12px',
                        padding: '20px 10px',
                        blockSize: 20,
                        insetBlockEnd: 'none',
                        cursor: col?.name !== 'action' ? 'pointer' : 'unset',
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (col?.name !== 'action') {
                          onRowClick && onRowClick(row);
                        }
                      }}
                    >
                      {dataProvider !== undefined
                        ? dataProvider?.func({ row: row })
                        : row[col?.name]}
                    </td>
                  );
                })}
              </tr>
            );
          })
        )
        }
      </tbody>}
    </React.Fragment>
  );
};

export default TableMainBody;
